const LANDING_ERROR_BOUNDARY__KEY = "landingErrorBoundary";
export default LANDING_ERROR_BOUNDARY__KEY;
